import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { setIsVideoTourScreen } from "slices";
import { HeaderBarComp } from "components";
import { getIsMaximized } from "slices/window-slice/index";

import TopBar from "./TopBar";
import FocusedVideoShow from "./FocusedVideoShow";
import VideosRow from "./VideosRow";
import MobileVideoShow from "./MobileVideoShow";

const VideoTourBox = () => {
  const dispatch = useDispatch();
  const isMaximized = useSelector(getIsMaximized);

  const closeVideoTourScreen = () => {
    dispatch(setIsVideoTourScreen(false));
  };

  return (
    <HeaderBarComp title={"Videos"} onBackButtonClick={closeVideoTourScreen}>
      <TopBar />
      <div className={`${isMaximized ? "hayley-px-2" : ""} `}>
        <FocusedVideoShow />
      </div>
      <MobileVideoShow />
      <VideosRow />
    </HeaderBarComp>
  );
};

export default VideoTourBox;
